import Link from 'next/link'

import { Shop } from 'modules/Shop/model/types'

import { Image } from 'shared/ui'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'

import styles from './ShopCard.module.scss'

interface ShopCardProps extends Pick<Shop, 'slug' | 'name' | 'logo'> {}

export function ShopCard({ slug, logo, name }: ShopCardProps) {
  return (
    <div className={styles.shopCard}>
      <Link href={ROUTER_PATHS.catalogShop.get(slug)} className={styles.link} />
      <div className={styles.imageWrapper}>
        <Image
          src={logo}
          alt="logo"
          width={180}
          height={100}
          className={styles.logo}
          style={{ objectFit: 'cover' }}
        />
      </div>
      <h3 className={styles.name}>
        <span>{name}</span>
      </h3>
    </div>
  )
}
